import { render, staticRenderFns } from "./ShippersView.vue?vue&type=template&id=cbfbc06c&scoped=true&"
import script from "./ShippersView.vue?vue&type=script&lang=js&"
export * from "./ShippersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfbc06c",
  null
  
)

export default component.exports